import { render, staticRenderFns } from "./LearningActivityCard.vue?vue&type=template&id=2879a23f&scoped=true&"
import script from "./LearningActivityCard.vue?vue&type=script&lang=js&"
export * from "./LearningActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningActivityCard.vue?vue&type=style&index=0&id=2879a23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879a23f",
  null
  
)

export default component.exports